import React from "react";
import styles from "./journey-event-info.module.css";
import { v4 } from "uuid";
import StandardRewardRow from "./standard-reward-row";
import { getUIText } from "../../translation";

export default function ArcanaEventInfo({ lang, arcana }) {
    return (
        <div className={styles["event"]} key={v4()}>
            <div className={styles["event-name"]}>
                [{getUIText(lang, "journey.arcana.event.prefix")}]{arcana.name[lang]}
            </div>
            <div className={styles["event-conditions"]}>
                <span className={styles["condition"]}>
                    {getUIText(lang, "simulator.savior.tactics.savior.title")} : {arcana.charName[lang]}
                </span>
            </div>
            <div className={styles["choices"]}>
                {arcana.events.map((event, index) => {
                    return (
                        <div className={styles["choice"]} key={v4()}>
                            {/* 이름+조건 */}
                            <div className={styles["choice-header"]}>
                                <span className={styles["choice-name"]}>
                                    {index + 1}. {event.name[lang]}
                                </span>
                            </div>
                            {/* 보상 */}
                            {event.choices.length > 0 && (
                                <div className={styles["choice-rewards"]}>
                                    {event.choices.map((choice, i) => {
                                        return (
                                            <div className={styles["arcana-choice"]} key={v4()}>
                                                {choice.name !== "" && (
                                                    <div
                                                        className={`${styles["arcana-choice-name"]} ${
                                                            i === 0 ? `${styles["success"]}` : `${styles["fail"]}`
                                                        }`}
                                                    >
                                                        {choice.name[lang]}
                                                    </div>
                                                )}
                                                <div
                                                    className={`${styles["reward-wrapper"]} ${styles["success"]} ${choice.failure_rewards.length === 0 ? styles["only"] : ""}`}
                                                    key={v4()}
                                                >
                                                    {choice.success_rewards.map((reward) => {
                                                        return <StandardRewardRow lang={lang} reward={reward} key={v4()} />;
                                                    })}
                                                </div>
                                                {choice.failure_rewards.length > 0 && (
                                                    <div className={`${styles["reward-wrapper"]} ${styles["fail"]}`} key={v4()}>
                                                        {choice.failure_rewards.map((reward) => {
                                                            return <StandardRewardRow lang={lang} reward={reward} key={v4()} />;
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
